import { Component, OnInit } from '@angular/core';
import { AuditoriaService } from './../../../services/http/auditoria.service';
import { FormGroup, FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-list-unidades-auditadas',
  templateUrl: './list-unidades-auditadas.component.html',
  styleUrls: ['./list-unidades-auditadas.component.scss']
})
export class ListUnidadesAuditadasComponent implements OnInit {

  listaResultado = [];
  total: number = 0;
  id: any;

  pesquisa = new FormGroup({
    'nomeFantasia': new FormControl(''),
  });

  params = {
    filter: {
      page: 1,
      nomeFantasia: '',
    },
    sorting: {
      nomeFantasia: 'asc'
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }
  activedRoute: any;

  constructor(private auditoriaService: AuditoriaService, private activatedRoute: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.auditoriaService.getListaUnidadesAuditadas(this.params).then(u => this.listaResultado = u);

    this.updateResult();

    this.pesquisa.valueChanges.pipe(distinctUntilChanged(), debounceTime(800)).subscribe(u => {
      this.params.filter = { ...this.params.filter, ...u };
      this.updateResult();
    });
    
  }

  removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  changeOrder() {
    this.params.sorting = this.removeEmpty({...this.params.sorting});
    this.auditoriaService.getListaUnidadesAuditadasFiltro(this.params).then(u => {
      this.total = u.total;
      this.listaResultado = u.lista;
    });
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult() {
    this.params.data = new Date();
    let dataUpdate = this.params.data;
    // this.auditoriaService.getListaUnidadesAuditadas(this.params).then(u => {
    //   if (dataUpdate == this.params.data) {
    //     this.total = u.total || 0;
    //     this.listaResultado = u.lista || [];
    //   }
    // });
  }

  editar(id) {
    // this.router.navigate(['/nova-associacao-auditoria', id]);
    this.router.navigate(['auditoria/adicionar-associacao-auditoria', id]);
  }


}
